<template>
  <div class="container" style="padding: 30px; margin-top: 50px">
    <div class="row">
      <h5>ระบบบริหารจัดการการให้กำลังใจการทำกิจกรรม</h5>
      <div class="col-md-6 mb-3 mt-3">

        <div class="card mt-3">
          <div class="card-body" style="text-align:center">
            กิจกรรมการเดิน
          </div>
        </div>
        <div class="card mt-3" style="margin-left:20px" v-for="w in walk_noti" :key="w.id">
          <div class="card-body" style="text-align:center">
            {{ w.header }}
          </div>
          <input type="text" class="form-control-lg mt-2" :placeholder="w.header"
            v-model="w.message">
        </div>
        <!-- <div class="card mt-3" style="margin-left:20px">
          <div class="card-body" style="text-align:center">
            ข้อความให้กำลังใจแก่ผู้เข้าร่วมโครงการดำเนินกิจกรรมไม่สำเร็จ
          </div>
        </div>
        <div class="card mt-3" style="margin-left:20px">
          <div class="card-body" style="text-align:center">
            ข้อความชื่นชมแก่ผู้เข้าร่วมโครงการดำเนินกิจกรรมสำเร็จ
          </div>
        </div> -->
        
      </div>

      <div class="col-md-6 mb-3 mt-3">
        <div class="card mt-3">
          <div class="card-body" style="text-align:center">
            กิจกรรมการบีบมือ
          </div>
        </div>
        <div class="card mt-3" style="margin-left:20px" v-for="w in hand_noti" :key="w.id">
          <div class="card-body" style="text-align:center">
           {{ w.header }}
          </div>
          <input type="text" class="form-control-lg mt-2" :placeholder="w.header"
            v-model="w.message">
        </div>
        <!-- <div class="card mt-3" style="margin-left:20px">
          <div class="card-body" style="text-align:center">
            ข้อความให้กำลังใจที่บีบมือครั้งที่ 1 ไม่สำเร็จ
          </div>
        </div>
        <div class="card mt-3" style="margin-left:20px">
          <div class="card-body" style="text-align:center">
            ข้อความให้กำลังใจที่บีบมือครั้งที่ 2 ไม่สำเร็จ
          </div>
        </div>
        <div class="card mt-3" style="margin-left:20px">
          <div class="card-body" style="text-align:center">
            ข้อความให้กำลังใจที่บีบมือครั้งที่ 3 ไม่สำเร็จ
          </div>
        </div>
        <div class="card mt-3" style="margin-left:20px">
          <div class="card-body" style="text-align:center">
            ข้อความให้คำชื่นชมที่บีบมือสำเร็จทั้ง 3 ครั้ง
          </div>
        </div> -->
      </div>
    </div>
    <button type="button" @click="Save" class="btn btn-success btn-lg position-absolute end-0 m-4 mt-5 mb-5">
      บันทึก
    </button>
  </div>
</template>

<script>

import MonitoringNumberService from "../services/MonitoringNumberService";
import ActivitiesService from "../services/ActivitiesService";

export default {
  name: "Nav",
  components: {
  },
  props: {
    msg: String,
  },
  data() {
    return {
      code_list: [],
      number_code_create: '',
      walk_noti: [],
      hand_noti: []
    };
  },
  mounted() {
    this.getMonitoringNumber();
    this.getWalkActivity()
    this.getHandActivity()
  },
  methods: {
    async Save() {
      await this.saveWalkActivity()
      await this.saveHandActivity()
      alert('บันทึกข้อมูลเรียบร้อยแล้ว')
      this.getWalkActivity()
      this.getHandActivity()
    },
    saveWalkActivity() {
      let data = {
        encourage_message: JSON.stringify(this.walk_noti),
        update_by: this.currentUser.id
      }
      ActivitiesService.updateactivities(1, data).then(() => {
        // console.log(res.data);
      });
    },
    saveHandActivity() {
      let data = {
        encourage_message: JSON.stringify(this.hand_noti),
        update_by: this.currentUser.id
      }
      ActivitiesService.updateactivities(2, data).then(() => {
        // console.log(res.data);
      });
    },
    getWalkActivity() {
      ActivitiesService.getactivity(1).then((res) => {
        this.walk_noti = JSON.parse(res.data.encourage_message)
        // console.log(this.walk_noti);
      });
    },
    getHandActivity() {
      ActivitiesService.getactivity(2).then((res) => {
        this.hand_noti = JSON.parse(res.data.encourage_message)
        // console.log(this.hand_noti);
      });
    },
    code_create() {
      if (this.number_code_create == '') {
        alert('กรุณากรอกจำนวนหมายเลขที่ต้องการสร้าง');
        return;

      }
      this.code_list = [];
      for (let i = 0; i < this.number_code_create; i++) {
        this.code_list.push(Math.floor(1000 + Math.random() * 9000));
      }
      this.create_monitoring_number()
    },
    create_monitoring_number() {
      // console.log(this.code_list);
      for (let c = 0; c < this.code_list.length; c++) {
        let monitoring_number = {
          random_number: this.code_list[c],
          create_by: this.currentUser.id,
          updated_by: this.currentUser.id
        }
        MonitoringNumberService.create_monitoring_number(monitoring_number).then(() => {
          // console.log(res.data);
        });

      }
      this.number_code_create = ''
      this.getMonitoringNumber()
    },
    getMonitoringNumber() {
      MonitoringNumberService.getmonitoring_numbers().then((res) => {
        this.list = res.data;
        // console.log(res.data);
      });
    },
  },
  computed: {
    loggedIn() {
      return this.$store.state.auth.status.loggedIn;
    },
    currentUser() {
      return this.$store.state.auth.user;
    },
  },
};
</script>

<style scoped></style>
